import React from "react";

function Icons(): JSX.Element {
  return (
    <div className="scrollbar-none relative z-10 flex h-44 w-full items-center justify-between overflow-x-auto bg-white px-[10%]">
      <img
        loading="lazy"
        src="images/icons/park.png"
        className="max-h-36 w-28 object-contain transition-all hover:scale-105 md:w-32 lg:w-44"
        alt="پارک علم و فناوری دانشگاه تهران"
      />

      <img
        loading="lazy"
        src="images/icons/kar.jpg"
        className="max-h-36 w-28 object-contain transition-all hover:scale-105 md:w-32 lg:w-44"
        alt="دانشکده کارآفرینی"
      />
      <img
        loading="lazy"
        src="images/icons/keshavarzi.jpg"
        className="max-h-36 w-28 object-contain transition-all hover:scale-105 md:w-32 lg:w-44"
        alt="اتاق بازرگانی"
      />
      <img
        loading="lazy"
        src="images/icons/namad.jpg"
        className="max-h-36 w-28 object-contain transition-all hover:scale-105 md:w-32 lg:w-44"
        alt="نماد اعتماد"
      />
      <img
        loading="lazy"
        src="images/icons/fani.jpg"
        className="max-h-36 w-28 object-contain transition-all hover:scale-105 md:w-32 lg:w-44"
        alt="سازمان آموزش فنی و حرفه ای"
      />
    </div>
  );
}

export default Icons;
